<template>
  <div class="renewalDetail">
    <p class="lien-text">原套餐</p>
    <equipment-detail
      v-if="details.BizOrderPackageInfo"
      :details="
        Object.assign(details.BizOrderPackageInfo, {
          ValidityEndTimeStr: details.EndTimeStr,
        })
      "
    ></equipment-detail>
    <p class="lien-text">续租套餐</p>
    <van-cell-group>
      <van-cell
        title="续租套餐："
        is-link
        :value="actions.length > 0 ? PackageItem.name : '暂无可选择套餐'"
        @click.native="changePackage"
      />
    </van-cell-group>
    <equipment-detail
      v-if="packageDetails.Id"
      :details="
        Object.assign(packageDetails, {
          Name: packageDetails.BizEquipmentVersionInfo.FullName,
        })
      "
      :FullName="false"
    ></equipment-detail>
    <template v-if="packageDetails.Id">
      <p style="padding-left: 10px">支付方式：</p>
      <van-radio-group v-model="payType">
        <van-cell-group>
          <van-cell clickable @click="payType = 'offline'">
            <template slot="title">
              <svg-icon
                slot="icon"
                icon-class="offline"
                class-name="icon-offline"
              ></svg-icon>
              线下支付
            </template>
            <van-radio name="offline" checked-color="#00d8a0"></van-radio>
          </van-cell>
          <van-cell title="微信支付" clickable @click="payType = 'onLine'">
            <template slot="title">
              <svg-icon
                slot="icon"
                icon-class="onLine"
                class-name="icon-onLine"
              ></svg-icon>
              微信支付
            </template>
            <van-radio name="onLine" checked-color="#00d8a0"></van-radio>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </template>
    <div>
      <p style="padding-left: 10px">备注内容：</p>
      <textarea
        name=""
        id=""
        cols=""
        rows="3"
        style="width: 100%; padding: 5px"
        v-model="Remarks"
      ></textarea>
    </div>

    <wx-pay
      :params="{ Id: ParentOrderId }"
      ref="refWxPay"
      class="pay-footer"
      :control="payType === 'onLine'"
      @successPay="successPay"
    >
      <div>
        合计：<span
          >￥{{
            packageDetails.Deposit + packageDetails.Price
              ? packageDetails.Deposit + packageDetails.Price
              : 0
          }}</span
        >
      </div>
      <van-button type="info" size="normal" @click="subRent">提 交</van-button>
    </wx-pay>
    <van-action-sheet
      v-model="ShowPackage"
      :actions="actions"
      @select="onSelect"
    />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "renewalDetail",
  data() {
    return {
      payType: "offline",
      orderId: "",
      ShowPackage: false,
      PackageItem: {
        name: "请选择套餐",
      },
      packageDetails: {
        Name: "请选择套餐",
      },
      actions: [],
      details: {
        BizOrderPackageInfo: {
          Name: "",
          Price: "",
          Deposit: "",
        },
        BizMemberInfo: {
          Headimgurl: "",
          FullAddress: "",
        },
      },
      PackageId: "",
      Remarks: "",
      ParentOrderId: ''
    };
  },
  methods: {
    successPay(val) {
      this.$toast.loading().clear();
      this.$dialog
        .alert({
          message:
            val === "chooseWXPay:ok"
              ? "订单支付成功！"
              : "订单已经提交成功，请完成支付！",
        })
        .then(() => {
          this.$router.push({
            path: "/userIn/orderDetails",
            query: { Id: this.orderId },
            replace: true,
          });
        });
    },
    onSelect(item, index) {
      this.PackageItem = item;
      this.getPackageDetails(item);
    },
    changePackage() {
      if (this.actions.length > 0) {
        this.ShowPackage = !this.ShowPackage;
      }
    },
    getPackageDetails(item) {
      const params = {
        Id: item.id,
      };
      this.$post("/BizMemberPackage/Details", params).then((res) => {
        this.packageDetails = res.Data;
        this.ShowPackage = !this.ShowPackage;
      });
    },
    getPackageList() {
      const params = {};
      params.DormitoryId = this.details.DormitoryId; // 判断是否存在地址修改后的数组，如果有则从数组中取，如果没有，则从源数据中返回宿舍ID
      params.Type = "续租";
      params.State = "发布";
      this.$post("/BizMemberPackage/AllList", params).then((res) => {
        this.actions = res.Data.map((item) => {
          return {
            name: item.FullName,
            id: item.Id,
          };
        });
      });
    },
    getDetail() {
      const params = {
        Id: this.$route.query.Id,
      };
      this.$post("/BizMemberOrder/Details", params).then((res) => {
        if (res) {
          this.details = res.Data;
          this.getPackageList();
        }
      });
    },
    subRent() {
      if (!this.PackageItem.id) {
        this.$toast("请选择套餐！");
        return false;
      }
      const params = {
        Id: this.$route.query.Id,
        PackageId: this.PackageItem.id,
        Remarks: this.Remarks,
        IsOnline: this.payType === "onLine",
      };
      this.$post("/BizMemberOrder/RenewalSend", params).then((res) => {
        if (res) {
          this.orderId = res.Data.Id;
          this.ParentOrderId = res.Data.ParentOrderId;
          if (this.payType === "offline") {
            this.$dialog
              .alert({
                message: "订单已经提交成功！",
              })
              .then(() => {
                this.$router.push({
                  path: "/userIn/orderDetails",
                  query: { Id: res.Data.Id },
                  replace: true,
                });
              });
          }
        }
      });
    },
    paySuccess(id) {},
  },
  mounted() {
    this.getDetail();
  },
};
</script>

<style scoped lang="less">
.renewalDetail {
  padding-bottom: 70px;
}
.pay-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  > div {
    margin-right: 10px;
    span {
      color: #ff6c6c;
    }
  }
  button {
    padding: 0 30px;
    background: #00d8a0 !important;
    border: 1px solid #00d8a0 !important;
  }
}
.packageStyle {
  margin-top: 10px;
}
textarea {
  border: 0;
}
</style>
